export default {
  api: {
    sso: {
      api_uri: process.env.REACT_APP_SSO_API_URI || 'https://sso.allbin.se',
      login_uri:
        process.env.REACT_APP_SSO_LOGIN_URI || 'https://login.allbin.se',
    },
    doc: {
      api_uri:
        process.env.REACT_APP_DOCS_API_URI || 'https://bulletin.api.allbin.se',
    },
    gtfs: {
      api_uri:
        process.env.REACT_APP_GTFS_API_URI || 'https://gtfs.test.allbin.se',
    },
  },
  slack: {
    webhook_uri:
      process.env.REACT_APP_SLACK_WEBHOOK_URI ||
      'https://hooks.slack.com/services/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',
  },
  google: {
    maps: {
      api_key:
        process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
        'AIzaSyA0tp0r6ImLSnn9vy4zXjZWar1F3U5eOaY',
    },
  },
  notifications: {
    urls: ['https://bulletin.api.allbin.se/notifications'],
  },
  root_uri: process.env.REACT_APP_ROOT_URI || 'https://bulletin.test.allbin.se',
  service_name: process.env.REACT_APP_SERVICE_NAME || 'bulletin_jlt',
  production: process.env.NODE_ENV === 'production',

  update_check_timer: 600000, //ms

  send_errors_to_slack_in_dev: false,

  // default_map_center: { lat: 57.7836902, lng: 14.1614415 },
  // default_map_zoom: 13,

  default_language: 'sv-SE',

  maximum_undo_steps: 100,

  default_thumbnail:
    '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',

  map_default_polyline_width: 6,
  map_default_polyline_color: '#000000',
  map_default_polyline_hover_width: 6,
  map_bus_route_preview_color: '#00ff00', //Used when hovering a bus route search result.
  map_bus_route_preview_width: 10, //Used when hovering a bus route search result.

  max_search_string_length: 32, //Max pattern length @ http://fusejs.io/ && https://en.wikipedia.org/wiki/Word_(computer_architecture)#Word_size_choice

  default_map_center: {
    lat: 57.78369,
    lng: 14.161442,
  },
  default_map_zoom: 10,
  map_available_polyline_colors: [
    '#ED6D38',
    '#663F92',
    '#E40520',
    '#F4A80D',
    '#2CAD76',
    '#2F91AC',
    '#000000',
  ],
  passing_route_styles: [
    {
      aliases: [],
      alias_range: [101, 873],
      style: {
        foreground: '#FFFFFF',
        background: '#ED6D38',
        shape: 'square',
      },
    },
    {
      aliases: [],
      alias_range: [11, 91],
      style: {
        foreground: '#FFFFFF',
        background: '#663F92',
        shape: 'square',
      },
    },
    {
      aliases: [1],
      style: {
        foreground: '#FFFFFF',
        background: '#E40520',
        shape: 'square',
      },
    },
    {
      aliases: [2],
      style: {
        foreground: '#FFFFFF',
        background: '#F4A80D',
        shape: 'square',
      },
    },
    {
      aliases: [3],
      style: {
        foreground: '#FFFFFF',
        background: '#2CAD76',
        shape: 'square',
      },
    },
    {
      aliases: [4],
      style: {
        foreground: '#FFFFFF',
        background: '#2F91AC',
        shape: 'square',
      },
    },
    {
      aliases: [199, 319, 126],
      style: {
        foreground: '#FFFFFF',
        background: 'rgb(0, 0, 0)',
        shape: 'square',
      },
    },
  ],
  passing_route_default_style: {
    foreground: '#FFFFFF',
    background: 'rgb(0, 0, 0)',
    shape: 'square',
  },

  //List of available icons 'selectable_marker_types' in EditMapView.
  legend_icon_default_text: {
    placed_bus_stop: 'Ordinarie busshållplats',
    placed_temporary_bus_stop: 'Tillfällig busshållplats',
    placed_temporary_bus_stop_red: 'Tillfällig busshållplats',
    placed_temporary_bus_stop_green: 'Tillfällig busshållplats',
    placed_temporary_bus_stop_blue: 'Tillfällig busshållplats',
    placed_temporary_bus_stop_orange: 'Ny busshållplats',
    placed_disruption: 'Vägarbete',
    placed_bus_stop_closed: 'Avstängd busshållplats',
  },

  legend_polyline_default_text: {
    solid: 'Ordinarie körväg / Ny körväg',
    dashed: 'Tillfällig körväg',
    temporary_break: 'Avstängd körväg',
    arrows: 'Bussen går i båda körriktningarna',
    one_way: 'Bussen går i en körriktningen',
    one_way_other: 'Bussen kör i en körriktningen',
  },

  hide_marker_type: [],

  enable_read_more_support: true,
  use_legend_priority: true,

  legend_priority_list: {
    placed_bus_stop: 0,
    placed_bus_stop_closed: 1,
    placed_temporary_bus_stop: 2,
    placed_temporary_bus_stop_red: 3,
    placed_temporary_bus_stop_blue: 4,
    placed_temporary_bus_stop_orange: 5,
    solid: 6,
    temporary_break: 7,
    dashed: 8,
    one_way: 9,
    arrows: 9,
    placed_disruption: 10,
  },

  default_bulletin_type: 'redirect_v2',

  //This will enable a button next to the "url" input for QR code which sets the QR url to the supplied value.
  //The URL is used to generate the QR code and detect if it is "the default".
  //For VL should be: `https://vl.se/trafikinformation`
  //For JLT should be: `https://www.jlt.se/trafikinformation`
  default_qr_link_url: 'https://www.jlt.se/trafikinformation',
  //Text to be used when default url is used. This should be the Complete text, including the URL, as it should be displayed!
  //For VL: `Se aktuella störningar via QR-koden eller på vl.se/trafikinformation.`
  //For JLT: `För mer information kontakta oss på 0771-444 333 eller läs mer på vår hemsida jlt.se.`
  default_qr_link_text: `För mer information kontakta oss på
    0771-444 333 eller läs mer på vår hemsida jlt.se.`,
};
